<template>
  <div>
    <ul class="question-type frc">
      <li class="name">类型</li>
      <li :class="0 == questionTypeIndex ? 'selected' : 'normal'" @click="toQuery(0)">全部</li>
      <template v-for="(item, index) in questionType">
        <li :key="index" :class="index + 1 == questionTypeIndex ? 'selected' : 'normal'" @click="toQuery(index + 1)">{{
          item.topicTypeName }}</li>
      </template>
    </ul>
    <div class="toolsb">
      <el-input class="mb-input" placeholder="请输入题目" v-model="query.topicContent"></el-input>
      <el-button type="primary" @click="SecQuery">搜索</el-button>
      <el-button type="primary" @click="resetQuery">重置</el-button>
      <!--
            <el-button type="success" @click="downLoadTemplateTap">下载模板</el-button>
            <el-upload
                style="margin: 0px 10px"
                :action="upAction"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                :headers="uploadHeader"
                :show-file-list="false"
                :on-success="uploadSuccess">
                <el-button type="success">导入考题</el-button>
            </el-upload>
            -->
      <el-button type="danger" @click="handleDeleteBatch">批量删除</el-button>
      <el-button type="primary" @click="handleAdd">新建题目</el-button>
    </div>
    <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" :stripe="true"
      :header-cell-style="tableHeaderCellStyle" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" />
      <el-table-column prop="topicContent" label="题目" align="center" show-overflow-tooltip />
      <el-table-column prop="topicTypeId" label="类型" align="center">
        <template slot-scope="scope">{{ scope.row.topicTypeId | topicTypeFilter }}</template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="correctAnswer" label="正确答案" align="center" />
      <el-table-column prop="mark" label="分值" align="center" />
      <el-table-column prop="courseName" label="所属课程" align="center" show-overflow-tooltip />
      <el-table-column prop="chapterName" label="所属章节" align="center" show-overflow-tooltip />
      <el-table-column prop="classesName" label="所属课时" align="center" show-overflow-tooltip />
      <el-table-column align="center" label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button type="text" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="mb-pagination" :current-page="curPage" layout="total, prev, pager, next" :total="total"
      @current-change="handleCurrentChange"></el-pagination>
    <!-- 新建题目 -->
    <el-dialog :title="dialogTitle == 0 ? '新建题目' : '编辑'" :visible.sync="dialogVisible" :width="dialogWidth"
      :close-on-click-modal="false">
      <el-form ref="mform" :rules="mformRules" :model="mform" label-width="100px" label-position="top">
        <el-form-item label="所属课程">
          <div class="frc">
            <el-select v-model="mform.courseId" placeholder="全部课程" clearable v-on:change="courseChangeTap">
              <template v-for="(item, index) in courseList">
                <el-option v-bind:key="index" :label="item.courseName" :value="item.courseId"></el-option>
              </template>
            </el-select>
            <p style="width: 10px"></p>
            <el-select v-model="mform.chapterId" placeholder="全部章节" clearable v-on:change="chapterChangeTap">
              <template v-for="(item, index) in chapterList">
                <el-option v-bind:key="index" :label="item.chapterName" :value="item.chapterId"></el-option>
              </template>
            </el-select>
            <p style="width: 10px"></p>
            <el-select v-model="mform.classesId" placeholder="全部课时" clearable>
              <template v-for="(item, index) in classesList">
                <el-option v-bind:key="index" :label="item.classesName" :value="item.classesId"></el-option>
              </template>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="mform.topicTypeId" placeholder="请选择" clearable>
            <template v-for="(item, index) in questionType">
              <el-option :key="index" :label="item.topicTypeName" :value="item.topicTypeId" />
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="题目" prop="topicContent">
          <el-input v-model="mform.topicContent" type="textarea" placeholder="请输入内容" clearable />
        </el-form-item>
        <!-- 单选类型 -->
        <template v-if="mform.topicTypeId == 1">
          <el-form-item label="选项">
            <ul class="m-answer">
              <li class="frc">
                <span class="m-margin-right">A</span>
                <el-input v-model="mform.aOption" placeholder="请输入内容" clearable />
              </li>
              <li class="frc">
                <span class="m-margin-right">B</span>
                <el-input v-model="mform.bOption" placeholder="请输入内容" clearable />
              </li>
              <li class="frc">
                <span class="m-margin-right">C</span>
                <el-input v-model="mform.cOption" placeholder="请输入内容" clearable />
              </li>
              <li class="frc">
                <span class="m-margin-right">D</span>
                <el-input v-model="mform.dOption" placeholder="请输入内容" clearable />
              </li>
            </ul>
          </el-form-item>
          <el-form-item label="正确答案">
            <el-radio v-model="mform.correctAnswer" label="A" />
            <el-radio v-model="mform.correctAnswer" label="B" />
            <el-radio v-model="mform.correctAnswer" label="C" />
            <el-radio v-model="mform.correctAnswer" label="D" />
          </el-form-item>
        </template>
        <!-- 多选类型 -->
        <template v-if="mform.topicTypeId == 2">
          <el-form-item label="选项">
            <ul class="m-answer">
              <li class="frc">
                <span class="m-margin-right">A</span>
                <el-input v-model="mform.aOption" placeholder="请输入内容" clearable />
              </li>
              <li class="frc">
                <span class="m-margin-right">B</span>
                <el-input v-model="mform.bOption" placeholder="请输入内容" clearable />
              </li>
              <li class="frc">
                <span class="m-margin-right">C</span>
                <el-input v-model="mform.cOption" placeholder="请输入内容" clearable />
              </li>
              <li class="frc">
                <span class="m-margin-right">D</span>
                <el-input v-model="mform.dOption" placeholder="请输入内容" clearable />
              </li>
              <li class="frc">
                <span class="m-margin-right">E</span>
                <el-input v-model="mform.eOption" placeholder="请输入内容" clearable />
              </li>
              <li class="frc">
                <span class="m-margin-right">F</span>
                <el-input v-model="mform.fOption" placeholder="请输入内容" clearable />
              </li>
            </ul>
          </el-form-item>
          <el-form-item label="正确答案">
            <el-checkbox-group v-model="checkList">
              <el-checkbox label="A" />
              <el-checkbox label="B" />
              <el-checkbox label="C" />
              <el-checkbox label="D" />
              <el-checkbox label="E" />
              <el-checkbox label="F" />
            </el-checkbox-group>
          </el-form-item>
        </template>
        <!-- 判断类型 -->
        <template v-if="mform.topicTypeId == 3">
          <el-form-item label="正确答案">
            <el-radio v-model="mform.correctAnswer" label="T">对</el-radio>
            <el-radio v-model="mform.correctAnswer" label="F">错</el-radio>
          </el-form-item>
        </template>
        <!-- 问答 -->
        <template v-if="mform.topicTypeId == 4">
          <el-form-item label="正确答案">
            <el-input v-model="mform.correctAnswer" type="textarea" placeholder="请输入描述信息" clearable />
          </el-form-item>
        </template>
        <el-form-item label="题目解析">
          <el-input v-model="mform.remark" type="textarea" placeholder="请输入描述信息" clearable />
        </el-form-item>
        <el-form-item label="分值">
          <el-input v-model="mform.mark" type="number" placeholder="请输入分值" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm('mform')">取 消</el-button>
        <el-button type="primary" @click="submitForm('mform')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 下载模板 -->
    <el-dialog title="下载模板" :visible.sync="dialogVisibleTemplate" :width="dialogWidth" :close-on-click-modal="false">
      <el-form label-width="100px" label-position="top">
        <el-form-item label="模板类型">
          <el-radio v-model="templateType" label="1">单选</el-radio>
          <el-radio v-model="templateType" label="2">多选</el-radio>
          <el-radio v-model="templateType" label="3">判断</el-radio>
          <el-radio v-model="templateType" label="4">问答</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleTemplateCancel">取 消</el-button>
        <a>
          <el-button type="primary" @click="downLoadTemplateTapB">开始下载</el-button>
        </a>
      </div>
    </el-dialog>
    <!-- 批量导入 -->
    <el-dialog title="批量导入" :visible.sync="dialogVisibleImport" :width="dialogWidth" :close-on-click-modal="false">
      <el-form label-width="100px" label-position="top">
        <el-form-item label="选择导入题目类型">
          <el-radio v-model="importType" label="1">单选</el-radio>
          <el-radio v-model="importType" label="2">多选</el-radio>
          <el-radio v-model="importType" label="3">判断</el-radio>
          <el-radio v-model="importType" label="4">问答</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-upload :action="upAction"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
          :headers="uploadHeader" :show-file-list="false" :on-success="uploadSuccess">
          <el-button style="float: right;margin-right: 10px;" type="primary" slot="trigger">开始导入</el-button>
          <el-button style="float: right" @click="dialogVisibleImportCancel">取 消</el-button>
        </el-upload>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import CommonStyle from "@/utils/CommonStyle";
  import Auth from "@/utils/Auth";
  export default {
    name: "QuestionDepository",
    components: {},
    filters: {
      topicTypeFilter (topicTypeId) {
        if (parseInt(topicTypeId) === 1) {
          return "单选";
        } else if (parseInt(topicTypeId) === 2) {
          return "多选";
        } else if (parseInt(topicTypeId) === 3) {
          return "判断";
        } else if (parseInt(topicTypeId) === 4) {
          return "问答";
        }
      }
    },
    data () {
      return {
        tableHeaderCellStyle: CommonStyle.tableHeaderCellStyle,
        multipleSelection: [],
        tableData: [],
        total: 0,
        curPage: 1,

        dialogWidth: "34%",
        dialogTitle: 0,
        dialogVisible: false, // 新建问题
        dialogVisibleTemplate: false, // 下载模板
        dialogVisibleImport: false, // 导入题库
        query: {
          topicContent: ""
        },
        checkList: [],
        mform: {},
        mformRules: {
          topicContent: [
            { required: true, message: "请输入", trigger: "change" }
          ]
        },
        classListIndex: 0,
        questionType: [],
        questionTypeIndex: 0,
        templateType: "", // 单选 下载模板
        importType: "", // 单选 批量导入
        uploadHeader: {
          Authorization: ""
        },
        upAction: "",
        courseList: [],
        chapterList: [],
        classesList: []
      };
    },
    mounted () {
      this.uploadHeader.Authorization = Auth.getToken();
      this.upAction = process.env.VUE_APP_PREFIX + "/learn/topic/importData/" + this.importType;
      this.toptypeList(this);
    },
    methods: {
      toptypeList (that) { // 问题类型列表
        that.HttpConnection.get("/learn/toptype/list", {
          params: {}
        }).then(function (response) {
          let _arrA = response.rows;
          that.questionType = _arrA;
          that.topicList(that, 1, 10);
          that.HttpConnection.get("/course/course/listCourseName", { params: {} }).then(function (response) { that.courseList = response.rows; });
        });
      },
      topicList (that, curPage) { // 题库列表
        console.log(that.questionTypeIndex);
        that.HttpConnection.get("/learn/topic/list", {
          params: {
            topicTypeId: that.questionTypeIndex,
            topicContent: that.query.topicContent,
            pageNum: curPage,
            pageSize: 10
          }
        }).then(function (response) {
          that.tableData = response.rows;
          that.total = response.total;
        });
      },
      handleDelete (index, row) {
        let that = this;
        this.$confirm("确定要删除该条记录吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          that.HttpConnection.delete("/learn/topic/remove/" + row.topicId).then(function (response) {
            that.$message({
              type: "success",
              message: "删除成功!"
            });
            that.topicList(that, that.curPage);
          });
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
      },
      handleDeleteBatch () {
        let that = this;
        this.$confirm("确定要删除该条记录吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          let ids = that.multipleSelection.map(function (item) {
            return item.topicId;
          });
          that.HttpConnection.delete("/learn/topic/batchRemove/" + ids).then(function (response) {
            that.$message({
              type: "success",
              message: "删除成功!"
            });
            that.topicList(that, that.curPage);
          });
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
      },
      submitForm (mform) {
        let that = this;
        this.$refs[mform].validate((valid) => {
          if (valid) {
            if (that.mform.topicTypeId === 2) {
              that.mform.correctAnswer = that.checkList.join("");
            }
            if (that.dialogTitle === 0) {
              that.HttpConnection.post("/learn/topic/save", that.mform).then(function (response) {
                that.topicList(that, that.curPage);
                that.dialogVisible = false;
                that.$message({
                  type: "success",
                  message: "添加成功!"
                });
              });
            } else if (that.dialogTitle === 1) {
              that.HttpConnection.put("/learn/topic/edit", that.mform).then(function (response) {
                that.topicList(that, that.curPage);
                that.dialogVisible = false;
                that.$message({
                  type: "success",
                  message: "编辑成功!"
                });
              });
            }
          }
        });
      },
      resetForm (formInfo) {
        this.dialogVisible = false;
        this.$refs[formInfo].resetFields();
      },
      resetQuery () {
        this.query.topicContent = "";
        this.topicList(this, this.curPage);
      },
      toolImport () {
        this.dialogVisibleImport = true;
      },
      handleAdd () {
        let that = this;
        that.dialogVisible = true;
        that.dialogTitle = 0;
        that.mform = { topicTypeId: 1 };
        that.checkList = [];
      },
      handleEdit (index, row) { // 修改题库
        let that = this;
        this.mform = {
          topicId: row.topicId,
          courseId: row.courseId,
          chapterId: row.chapterId,
          classesId: row.classesId,
          topicTypeId: row.topicTypeId,
          topicContent: row.topicContent,
          aOption: row.aOption,
          bOption: row.bOption,
          cOption: row.cOption,
          dOption: row.dOption,
          eOption: row.eOption,
          fOption: row.fOption,
          correctAnswer: row.correctAnswer,
          mark: row.mark, // 得分
          remark: row.remark // 描述信息
        };
        if (row.topicTypeId === 2) {
          this.checkList = row.correctAnswer.split("");
        }
        this.courseChangeTap();
        this.chapterChangeTap();
        this.dialogVisible = true;
        this.dialogTitle = 1;
      },
      downLoadTemplateTap () { // 下载模板 弹出层
        this.dialogVisibleTemplate = true;
      },
      dialogVisibleTemplateCancel () { // 取消模板下载的弹出层
        this.dialogVisibleTemplate = false;
      },
      dialogVisibleImportCancel () { // 导入模板
        this.dialogVisibleImport = false;
      },
      downLoadTemplateTapB () { // 下载模板 确认
        let that = this;
        this.$confirm("确定下载模板?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          let a = document.createElement("a"); //创建一个<a></ a>标签
          a.href = "static/offlineRecordTemp.xlsx"; // 给a标签的href属性值加上地址，注意，这里是绝对路径，不用加 点.
          a.download = "考核成绩录入模板.xlsx"; //设置下载文件文件名，这里加上.xlsx指定文件类型，pdf文件就指定.fpd即可
          a.style.display = "none"; // 障眼法藏起来a标签
          document.body.appendChild(a); // 将a标签追加到文档对象中
          a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
          a.remove(); // 一次性的，用完就删除a标签
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
      },
      handleSelectionChange (val) {
        this.multipleSelection = val;
      },
      handleCurrentChange (val) {
        this.curPage = val;
        this.topicList(this, val);
      },
      toQuery (index) {
        this.questionTypeIndex = index;
        this.topicList(this, 1, 10);
      },
      SecQuery () {
        this.topicList(this, 1, 10);
      },
      uploadSuccess (res, file) { // 上传文件成功之后
        let that = this;
        if (res.code === 200) {
          that.$message.success(res.data.msg);
        } else {
          that.$message.error("导入失败！");
        }
        this.topicList(this, this.curPage);
      },
      courseChangeTap () { // 课程下拉框
        let that = this;
        that.HttpConnection.get("/course/chapter/list", {
          params: {
            courseId: that.mform.courseId
          }
        }).then(function (response) {
          that.chapterList = response.rows;
        });
      },
      chapterChangeTap () { // 章节下拉框
        let that = this;
        that.HttpConnection.get("/course/classes/classesNameList", {
          params: {
            chapterId: that.mform.chapterId
          }
        }).then(function (response) {
          that.classesList = response.data;
        });
      }
    }
  };
</script>

<style scoped lang="scss">
  .question-type {
    background-color: #f5f7fa;
    padding: 40px 30px;
    margin: 0px 0px 26px 0px;

    .name {
      color: #99a9bf;
      margin: 0px 40px 0px 0px;
    }
  }

  .m-answer {
    li {
      margin: 10px 0px;

      .m-margin-right {
        margin: 0px 10px 0px 0px;
      }
    }
  }

  .selected {
    padding: 4px 16px;
    cursor: pointer;
    margin: 0px 10px;
    background-color: #1e6af1;
    color: #ffffff;
  }

  .normal {
    padding: 4px 16px;
    cursor: pointer;
    margin: 0px 10px;
  }
</style>